export class Navigation {
	private currentScrollY: number;

	constructor() {
		const navigationToggles: NodeListOf<HTMLElement> =
			document.querySelectorAll('.navigation-toggle');
		navigationToggles.forEach((item: HTMLElement) =>
			item.addEventListener('click', (): void => Navigation.toggleNavigation())
		);

		document
			.querySelector('.navigation-overlay')
			?.addEventListener('click', (): void => Navigation.toggleNavigation());
		window.addEventListener('scroll', () => this.onScroll(), { passive: true });

		const ua: string = navigator.userAgent.toLowerCase();

		if (ua.indexOf('android') > -1) {
			document
				.querySelector('.menu-item-has-children')
				?.addEventListener('touchstart', (event: TouchEvent) =>
					Navigation.handleHover(event)
				);
		}

		this.currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
		this.onScroll();
	}

	private static toggleNavigation(): void {
		document.body.classList.toggle('sub-navigation-is-visible');
	}

	private static handleHover(event: TouchEvent): void {
		if (!document.body.classList.contains('sub-navigation-is-visible')) {
			event.preventDefault();
			document.body.classList.add('sub-navigation-is-visible');
		}
	}

	private onScroll(): void {
		const newScrollY: number = window.pageYOffset || document.documentElement.scrollTop;

		if (newScrollY > 0 && newScrollY > this.currentScrollY) {
			document.body.classList.add('header-is-hidden');
			document.body.classList.remove('sub-navigation-is-visible');
		} else {
			document.body.classList.remove('header-is-hidden');

			if (newScrollY < 50) {
				document.body.classList.remove('header-has-bg-color');
			} else {
				document.body.classList.add('header-has-bg-color');
			}
		}

		this.currentScrollY = newScrollY;
	}
}
